import { atomFamily } from "jotai/utils";

import { UnUploadedImage } from "components/PhotoUpload/types";

import { createDerivedSessionAtom } from "atoms/utils/createDerivedSessionAtom";
import { createPersistedAtom } from "atoms/utils/createPersistedAtom";

export const sessionMileageAtom = atomFamily((sessionId: string) => createPersistedAtom(`mileage-${sessionId}`, ""));
export const mileageAtom = createDerivedSessionAtom<string>(sessionMileageAtom);

const sessionMileagePhotoAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<UnUploadedImage[]>(`mileagePhoto-${sessionId}`, [])
);
export const mileagePhotoAtom = createDerivedSessionAtom<UnUploadedImage[]>(sessionMileagePhotoAtom);

const sessionMilageWarningAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`mileageWarning-${sessionId}`, "")
);
export const mileageWarningAtom = createDerivedSessionAtom<string>(sessionMilageWarningAtom);
